<div class="table">
  <div *ngIf="isGestionComptesFacturation" class="card">
    <h3 *ngIf="!updateMode">{{ preferenceMessages.tab_4_label_2 | translate }}</h3>
    <h3 *ngIf="updateMode">{{ preferenceMessages.tab_4_label_2_bis | translate }}</h3>
    <div class="oneLine">
      <p>{{ preferenceMessages.tab_4_label_4_part1 | translate }}</p>
      <p class="red">&nbsp;*&nbsp;</p>
      <p>{{ preferenceMessages.tab_4_label_4_part2 | translate }}</p>
    </div>
    <form class="form" [formGroup]="form">
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_intitule | translate" [type]="'text'"
                      [rule]="'required'" [name]="'preference_SepAtt_facturation_SepAtt_intitule'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_organisme | translate" [type]="'text'"
                      rule="required|maxSize_38" [name]="'preference_SepAtt_facturation_SepAtt_nomOrganisme'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_classe_profit | translate"
                      [type]="'select'"
                      [optionsWithCode]="optionsClasseProfit" [disabled]="false" [rule]="'required'"
                      [name]="'preference_SepAtt_facturation_SepAtt_classeProfit'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_siret | translate" [type]="'text'"
                      [rule]="'required'" [disabled]="isSiretDisabled"
                      [name]="'preference_SepAtt_facturation_SepAtt_siret'">
      </app-form-input>

      <!-- Intégration typeEntite -->
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_type_entite | translate"
                      [type]="'radio'"
                      [value]="itemEnCours?.typeEntite || null"
                      [radios]="radiosValueTypeEntite"
                      [rule]="'required'" [name]="'preference_SepAtt_facturation_SepAtt_typeEntite'">
      </app-form-input>

      <ng-container *ngIf="selectedTypeEntite === TypeEntite.PriveeAssujettie">
        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_identifiant_adressage | translate"
                        [type]="'text'" [value]="itemEnCours?.identifiantAdressage"
                        rule="minSize_9|maxSize_125" [name]="'preference_SepAtt_facturation_SepAtt_identifiantAdressage'">
        </app-form-input>
        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_ref_bon_commande | translate"
                        [type]="'text'" [value]="itemEnCours?.refBonCommande"
                        rule="minSize_3|maxSize_50" [name]="'preference_SepAtt_facturation_SepAtt_refBonCommande'">
        </app-form-input>
      </ng-container>
      <ng-container *ngIf="selectedTypeEntite === TypeEntite.Publique">
        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_executant | translate"
                        [type]="'text'" [value]="itemEnCours?.noExecutant"
                        [rule]="''" [name]="'preference_SepAtt_facturation_SepAtt_executant'">
        </app-form-input>
        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_engagement | translate"
                        [type]="'text'" [value]="itemEnCours?.noEngagementJuridique"
                        [rule]="''" [name]="'preference_SepAtt_facturation_SepAtt_engagement'">
        </app-form-input>
      </ng-container>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_destinataire | translate"
                      [type]="'text'" [rule]="''" [name]="'preference_SepAtt_facturation_SepAtt_destinataire'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_immeuble | translate" [type]="'text'"
                      [rule]="''" [name]="'preference_SepAtt_facturation_SepAtt_immeuble'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_voie | translate" [type]="'text'"
                      [rule]="'required'" [name]="'preference_SepAtt_facturation_SepAtt_voie'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_complement | translate"
                      [type]="'text'" [rule]="''" [name]="'preference_SepAtt_facturation_SepAtt_complement'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_cp | translate" [type]="'text'"
                      [rule]="'required'" [name]="'preference_SepAtt_facturation_SepAtt_cp'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_pays | translate" [type]="'select'"
                      [typeSelect]="optionsSelectType"
                      [optionsWithCode]="optionsSelect" [disabled]="false" [rule]="'pattern_25'"
                      [errorMessage]="{'pattern' : 'ctr_48'}" [name]="'preference_SepAtt_facturation_SepAtt_pays'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_ville | translate" [type]="'text'"
                      [rule]="'required'" [name]="'preference_SepAtt_facturation_SepAtt_ville'">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_4_label_tva | translate" [type]="'text'"
                      [rule]="''" [name]="'preference_SepAtt_facturation_SepAtt_tva'">
      </app-form-input>
      <div class="buttonsGroup">
        <button *ngIf="!updateMode" id="ajouter" [disabled]="(!form.valid)" (click)="savePref()"
                class="btn btn-primary">
          {{ preferenceMessages.tab_4_label_ajouter | translate }}
        </button>
        <button *ngIf="updateMode" id="ajouter" [disabled]="(!form.valid)" (click)="savePref()" class="btn btn-primary">
          {{ preferenceMessages.tab_4_label_modifier | translate }}
        </button>
        <button id="annuler" (click)="annuler()" class="btn btn-outline-primary">
          {{ preferenceMessages.tab_4_label_annuler | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="card">
    <h3>{{ preferenceMessages.tab_4_label_3 | translate }}</h3>
    <div id="etiquette-group">
      <div *ngFor="let item of preferencesTableau" class="etiquette">
        <span class="text-etiquette">{{ item.nomOrganisme }} - {{ item.siret }}</span>
        <div *ngIf="isGestionComptesFacturation" class="icon-etiquette">
          <mat-icon class="icon" (click)="setUpdateMode(item)">create</mat-icon>
        </div>
        <div *ngIf="isGestionComptesFacturation" class="icon-etiquette">
          <mat-icon class="icon" (click)="delete(item.id)">highlight_off</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
